import type { WorkoutType } from 'src/app/pages/workout/util';
import styled from 'styled-components';
import PresentationIcon from 'app/assets/presentation-icon.svg';
import { useIntl } from 'react-intl';
import { isInIframe } from 'src/app/utils/in-app-comunication/utils';
import useConfig from 'app/config';
import { appendSessionId } from 'app/utils/analytics/recordrelay/session';
import { useSearchParams } from 'react-router-dom';
import { useAppState } from 'state';

const PresentationButton = styled.div`
  cursor: pointer;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  gap: ${({ theme }) => theme.spacing(2)};
  border-radius: ${({ theme }) => theme.spacing(8)};
  background: ${({ theme }) => theme.colors.white};
  color: ${({ theme }) => theme.colors.black};
  width: 100%;
  margin: ${({ theme }) => `${theme.spacing(4)} 0 ${theme.spacing(6)}`};
  padding: ${({ theme }) => `${theme.spacing(2)} 0`};
`;

type WhiteboardButtonProps = {
  onOpenWhiteboard: () => void;
  workout: WorkoutType;
};

const WhiteboardButton: React.FC<WhiteboardButtonProps> = ({ onOpenWhiteboard, workout }) => {
  const [searchParams] = useSearchParams();
  const displayLegacyWhiteboard = searchParams.get('displayLegacyWhiteboard') === 'true';
  const intl = useIntl();
  const { config } = useConfig();
  const consentType = useAppState(({ cookieConsent }) => cookieConsent.consentType);
  const openCoachingViewLabel = intl.formatMessage({ id: 'whiteboard.open' });
  const handleOpenWhiteboard = () => {
    const shouldLinkOutToOneFiit = !isInIframe() && !displayLegacyWhiteboard;
    if (shouldLinkOutToOneFiit) {
      const currentUrl = encodeURIComponent(window.location.href);
      const baseUrl = `${config.REACT_APP_WHITEBOARD_URL}?subpath=${workout.id}/whiteboard-selection&client_id=${config.REACT_APP_CLIENT_ID_FOR_ONE_FIIT}&from=${currentUrl}`;
      window.location.href = consentType === 'all' ? appendSessionId(baseUrl) : baseUrl;
    } else {
      onOpenWhiteboard();
    }
  };
  return (
    <PresentationButton onClick={handleOpenWhiteboard} data-testid="coach-button">
      <img src={PresentationIcon} alt="Presentation Icon" />
      {openCoachingViewLabel}
    </PresentationButton>
  );
};

export default WhiteboardButton;
